import { useRef, type RefObject } from 'react';
import { filmPlaceTitleOpacity, placeTitleOpacity, type PlaceTitle as PlaceTitleSettings } from '../../../renderer/src/place-title';
import { usePlaceTitlePlacement } from '../hooks/use-place-title-placement';
import './place-title.css';

interface Properties {
  title: PlaceTitleSettings;
  seconds: number;
  durationSeconds?: number | undefined;
  overlayTarget?: RefObject<HTMLDivElement | null> | undefined;
  appearance?: 'night-hawk' | undefined;
}

/** Fits location type into clear map space between the information plates. */
export function PlaceTitle({ title, seconds, durationSeconds, overlayTarget, appearance }: Properties) {
  const root = useRef<HTMLDivElement>(null);
  const lockup = useRef<HTMLDivElement>(null);
  usePlaceTitlePlacement(root, lockup, overlayTarget, title.name, title.region);
  return <div ref={root} className="place-title" data-appearance={appearance} data-composition-element="Place title"
    style={{ opacity: durationSeconds === undefined ? placeTitleOpacity(seconds) : filmPlaceTitleOpacity(seconds, durationSeconds) }}>
    <div ref={lockup} className="place-title-lockup"><span className="place-title-name">{title.name}</span>
      {title.region && <span className="place-title-region">{title.region}</span>}</div>
  </div>;
}
